"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fetch = void 0;
var tslib_1 = require("tslib");
var models_1 = require("../models");
var Fetch = /** @class */ (function () {
    function Fetch() {
    }
    Fetch.prototype.post = function (authSuiteFetchData) {
        return this.fetch(tslib_1.__assign(tslib_1.__assign({}, authSuiteFetchData), { method: models_1.RequestMethod.POST }));
    };
    Fetch.prototype.get = function (authSuiteFetchData) {
        return this.fetch(tslib_1.__assign(tslib_1.__assign({}, authSuiteFetchData), { method: models_1.RequestMethod.GET }));
    };
    Fetch.prototype.put = function (authSuiteFetchData) {
        return this.fetch(tslib_1.__assign(tslib_1.__assign({}, authSuiteFetchData), { method: models_1.RequestMethod.PUT }));
    };
    Fetch.prototype.delete = function (authSuiteFetchData) {
        return this.fetch(tslib_1.__assign(tslib_1.__assign({}, authSuiteFetchData), { method: models_1.RequestMethod.DELETE }));
    };
    Fetch.prototype.patch = function (authSuiteFetchData) {
        return this.fetch(tslib_1.__assign(tslib_1.__assign({}, authSuiteFetchData), { method: models_1.RequestMethod.PATCH }));
    };
    Fetch.prototype.getPath = function (authSuiteFetchData) {
        return this.requestPathService.getFullPath(authSuiteFetchData);
    };
    return Fetch;
}());
exports.Fetch = Fetch;
